module.exports = __webpack_public_path__ + "dist/assets/img/webfront.7bcecedb.svg";